import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private activedRoute: ActivatedRoute) {}
  ngOnInit(): void {
    this.activedRoute.params.subscribe((params) => {
      console.log(params);
    });
  }
}
